export default __webpack_public_path__ + "static/media/hero-image-01.cf7f7105.png";